import React from 'react';
import PropTypes from 'prop-types';
import ConnectedTags from '../ConnectedTags';
import SegmentPhotos from '../SegmentPhotos';
import './styles.scss';

function SegmentDetail({ segmentId, userId }) {
    return (
        <div className="col-md-12 segment-detail">
            <div className="content-box">
                <ul className="nav nav-tabs" id="segmentDetail" role="tablist">
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            id="tags-tab"
                            data-toggle="tab"
                            href="#tags"
                            role="tab"
                            aria-controls="tags"
                            aria-selected="false"
                        >
                            <h2 className="title">Tags</h2>{' '}
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            id="photos-tab"
                            data-toggle="tab"
                            href="#photos"
                            role="tab"
                            aria-controls="photos"
                            aria-selected="true"
                        >
                            <h2 className="title">Photos</h2>
                        </a>
                    </li>
                </ul>
                <div className="tab-content" id="segmentDetailContent">
                    <div
                        className="tab-pane fade show active"
                        id="tags"
                        role="tabpanel"
                        aria-labelledby="tags-tab"
                    >
                        <ConnectedTags segmentId={segmentId} />
                    </div>
                    <div
                        className="tab-pane fade"
                        id="photos"
                        role="tabpanel"
                        aria-labelledby="photos-tab"
                    >
                        <SegmentPhotos segmentId={segmentId} userId={userId} />
                    </div>
                </div>
            </div>
        </div>
    );
}

SegmentDetail.propTypes = {
    segmentId: PropTypes.string,
    userId: PropTypes.string,
};

export default SegmentDetail;
